import React from 'react';

function CookiePolicy() {
  return (
    <div style={{ padding: '20px', maxWidth: '800px', margin: 'auto', lineHeight: '1.6' }}>
      <h2>Cookie Policy della Web App di Ristorante Duomila</h2>
      <p><strong>Ultimo aggiornamento: 02/08/2025</strong></p>

      <p>
        Questa Cookie Policy spiega cosa sono i cookie e come vengono utilizzati dalla nostra web app 
        disponibile all'indirizzo https://duomila-webapp2.web.app.
      </p>

      <h3>1. Cosa sono i Cookie?</h3>
      <p>
        I cookie sono piccoli file di testo che i siti visitati dall'utente inviano e registrano sul suo 
        computer o dispositivo mobile, per essere poi ritrasmessi agli stessi siti alla successiva visita.
      </p>

      <h3>2. Cookie Utilizzati da questa Web App</h3>
      <p>Questa web app utilizza le seguenti tipologie di cookie:</p>
      <ul>
        <li>
          <strong>Cookie Tecnici (strettamente necessari)</strong>
          <p>
            Questi cookie sono essenziali per il corretto funzionamento della web app e per permettere all'utente di navigare 
            e utilizzare le sue funzionalità. Ad esempio, vengono utilizzati per gestire la sessione di navigazione e per 
            memorizzare i prodotti che l'utente aggiunge al proprio ordine prima di inviarlo. Per l'installazione 
            di tali cookie non è richiesto il preventivo consenso degli utenti.
          </p>
        </li>
        <li>
          <strong>Servizi di Terze Parti (Google Fonts)</strong>
          <p>
            Questa web app utilizza Google Fonts, un servizio di visualizzazione di stili di carattere gestito da Google Ireland 
            Limited o da Google LLC, a seconda della località da cui l'utente accede. Questo servizio potrebbe comportare che, 
            per visualizzare correttamente i caratteri, il browser dell'utente si connetta ai server di Google, il quale 
            potrebbe venire a conoscenza dell'indirizzo IP dell'utente.
            <br />
            Per maggiori informazioni, si prega di consultare la privacy policy di Google: 
            <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">
              https://policies.google.com/privacy
            </a>
          </p>
        </li>
      </ul>

      <h3>3. Gestione dei Cookie</h3>
      <p>
        L'utente può gestire le preferenze relative ai cookie direttamente all'interno del proprio browser ed impedire – 
        ad esempio – che terze parti possano installarne. Tramite le preferenze del browser è inoltre possibile 
        eliminare i cookie installati in passato. È importante notare che disabilitando tutti i cookie, 
        il funzionamento di questo sito potrebbe essere compromesso.
        L'utente può trovare informazioni su come gestire i cookie nel suo browser ai seguenti indirizzi:
      </p>
      <ul>
        <li><a href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noopener noreferrer">Google Chrome</a></li>
        <li><a href="https://support.mozilla.org/it/kb/Gestione%20dei%20cookie" target="_blank" rel="noopener noreferrer">Mozilla Firefox</a></li>
        <li><a href="https://support.apple.com/it-it/guide/safari/sfri11471/mac" target="_blank" rel="noopener noreferrer">Apple Safari</a></li>
        <li><a href="https://support.microsoft.com/it-it/microsoft-edge/eliminare-i-cookie-in-microsoft-edge-63947406-40ac-c3b8-57b9-2a946a29ae09" target="_blank" rel="noopener noreferrer">Microsoft Edge</a></li>
      </ul>

      <h3>4. Titolare del Trattamento</h3>
      <p>
        Il titolare del trattamento è Ristorante Duomila Srls, come identificato nella Privacy Policy.
      </p>
    </div>
  );
}

export default CookiePolicy;